import { get } from 'lodash';

import * as PreSettleApi from '@/api/bill/preSettle';
import actionTypes from './actionType';

const togglePreSettleDrawerVisible = (visible) => {
  return {
    type: actionTypes.TOGGLE_PRE_SETTLE_DRAWER_VISIBLE,
    payload: {
      drawerVisible: visible,
    },
  };
};

const setPreSettleInfoLoading = (loading) => {
  return {
    type: actionTypes.SET_PRE_SETTLE_INFO_LOADING,
    payload: {
      infoLoading: loading,
    },
  };
};

const initPreSettleInfo = (params) => {
  return async (dispatch) => {
    dispatch(setPreSettleInfoLoading(true));
    try {
      const res = await PreSettleApi.fetchV2PreSettleInfo(params);
      dispatch(setPreSettleInfoLoading(false));
      dispatch({
        type: actionTypes.FETCH_PRE_SETTLE_INFO,
        payload: {
          preSettleInfo: get(res, 'data', {}),
        },
      });
    } catch (err) {
      dispatch(setPreSettleInfoLoading(false));
    }
  };
};

const resetPreSettleInfo = () => {
  return {
    type: actionTypes.RESET_PRE_SETTLE_INFO,
    payload: {},
  };
};

const setPreSettleBizNo = (preSettleBizNo) => {
  return {
    type: actionTypes.SET_PRE_SETTLE_BIZ_NO,
    payload: {
      preSettleBizNo,
    },
  };
};

export { togglePreSettleDrawerVisible, initPreSettleInfo, resetPreSettleInfo, setPreSettleBizNo };
